import { render, staticRenderFns } from "./BDXStatusPendingManagerList.vue?vue&type=template&id=39c2d199&scoped=true"
import script from "./BDXStatusPendingManagerList.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManagerList.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingManagerList.vue?vue&type=style&index=0&id=39c2d199&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c2d199",
  null
  
)

export default component.exports